module.exports = __webpack_public_path__ + "img/michal-sawtyruk-day-out.754c9be.jpg";